import React, { useRef, useReducer, useState } from 'react';

import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';

import Email from './Email';
import VerifyOtp from './VerifyOtp';
import ResetPassword from './ResetPassword';

function ForgotPassword({ onClose, ...props }) {
  const [email, setEmail] = useState('');

  const [formStep, updateFormStep] = useReducer(
    formStepReducer,
    FORM_STEP.EMAIL
  );

  const otpReferenceId = useRef(null);

  function handleClose() {
    otpReferenceId.current = null;
    setEmail('');
    updateFormStep({ payload: FORM_STEP.EMAIL });
    onClose();
  }

  return (
    <Dialog
      onClose={handleClose}
      PaperProps={{ sx: { borderRadius: 8, flex: '1 1 0' } }}
      maxWidth='xs'
      {...props}
    >
      <DialogContent>
        {formStep === FORM_STEP.EMAIL && (
          <Email
            updateFormStep={updateFormStep}
            otpReferenceId={otpReferenceId}
            email={email}
            onChange={({ target: { value } }) => setEmail(value)}
          />
        )}

        {formStep === FORM_STEP.VERIFY_CODE && (
          <VerifyOtp
            updateFormStep={updateFormStep}
            otpReferenceId={otpReferenceId}
          />
        )}

        {formStep === FORM_STEP.RESETPASSWORD && (
          <ResetPassword closeModal={handleClose} email={email} />
        )}
      </DialogContent>
    </Dialog>
  );
}

const FORM_STEP = Object.freeze({
  EMAIL: 'EMAIL',
  VERIFY_CODE: 'VERIFY_CODE',
  RESETPASSWORD: 'RESETPASSWORD',
});

function formStepReducer(state, action) {
  switch (action.payload) {
    case FORM_STEP.EMAIL:
      return FORM_STEP.EMAIL;
    case FORM_STEP.VERIFY_CODE:
      return FORM_STEP.VERIFY_CODE;
    case FORM_STEP.RESETPASSWORD:
      return FORM_STEP.RESETPASSWORD;
    default:
      return state;
  }
}

export default ForgotPassword;
export { FORM_STEP };
